export default function CheckIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.36667 11.7156C6.27778 11.7156 6.19444 11.7016 6.11667 11.6736C6.03889 11.6461 5.96667 11.599 5.9 11.5323L3.03333 8.66562C2.91111 8.5434 2.85267 8.38496 2.858 8.19029C2.86378 7.99607 2.92778 7.83785 3.05 7.71562C3.17222 7.5934 3.32778 7.53229 3.51667 7.53229C3.70556 7.53229 3.86111 7.5934 3.98333 7.71562L6.36667 10.099L12.0167 4.44896C12.1389 4.32674 12.2973 4.26562 12.492 4.26562C12.6862 4.26562 12.8444 4.32674 12.9667 4.44896C13.0889 4.57118 13.15 4.7294 13.15 4.92362C13.15 5.11829 13.0889 5.27674 12.9667 5.39896L6.83333 11.5323C6.76667 11.599 6.69444 11.6461 6.61667 11.6736C6.53889 11.7016 6.45556 11.7156 6.36667 11.7156Z"
        fill="white"
      />
    </svg>
  );
}
